<template>
  <div class="cms-youtube-cid">
    <el-dialog
      :title="dialogTitle"
      :visible="asset_label_dialog"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setAssetLabelDialog(false)"
      @open="open"
    >
      <el-form label-position="top">
        <p>Assign Owner to <strong>{{asset_label.name}}</strong></p>
        <el-form-item prop="owner">
          <el-select v-model="selectedOwner" clearable filterable class="mr10">
            <el-option
                v-for="a in unassigned_users"
                :key="a.id"
                :value="a.id"
                :label="a.email"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      active: false,
      selectedOwner: null,
    }
  },
  computed: {
    ...mapState('youtubeUsers', ['asset_label_dialog', 'loading', 'asset_label', "unassigned_users"]),
    dialogTitle: function() {
      return 'Assign Owner'
    },
  },

  methods: {
    ...mapActions('youtubeUsers', ["readUnassignedUsers", "assignLabelOwner", "listAssetLabels"]),
    ...mapMutations('youtubeUsers', ['setAssetLabelDialog']),

    submit() {
      const payload = {
        user_id: this.selectedOwner,
        label_id: this.asset_label.id
      }
      this.assignLabelOwner(payload)
      this.$message({
        type: 'success',
        message: 'Ownership successfully added'
      })
      this.readUnassignedUsers()
      this.listAssetLabels()
      this.selectedOwner = null;
      this.setAssetLabelDialog(false)
    },

    open(){
      // this.readUnassignedUsers()
    },
  }
}
</script>

<style scoped lang="scss">

</style>
